export default "__VITE_ASSET__CI$c1Ofl__"